
import { defineComponent,inject, PropType } from "vue";

import api from "@/api/axios";
import Toast from "@/components/UI/Toast/";
import useShopCar from "@/hooks/useShopCar";
import $ from "jquery";
import Modal from "@/components/UI/Modal";
import router from "@/router";
export default defineComponent({
  name: "slotFooter",
  props: {
    tid: {
      type: String,
      default: "",
    },
    pid: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "1",
    },
    isFav: {
      type: Boolean,
      default: false,
    },
    viewCartText: {
      type: String,
      default: "查看购物车",
    },
    lotid: {
      type: String,
      default: "0"
    },
    tcid: {
      type: String,
      default: "0"
    },
    stock: {
      type: Number,
      default: null
    },
    buttonType:{
      type:Number,
      default:1
    }
  },
  setup(props) {
    //  add shop car
    const { addShopCar ,storgeBackstage} = useShopCar();
    const userInfo = inject("userInfo") as any;
    //查看购物车
    function toViewCart() {

        router.push({name: "ShopCar"});

    }
    //去申请试用
    function detailToApplyOrder(pid: any, lotid: any) {

        storgeBackstage(pid, 0, 1,lotid,0,2,1,0);
        //子组件中修改父组件传递过来的值
        this.$emit('update:buttonType', 1)

    }
    function collectAction() {
      const formData = new FormData();
      formData.append("id", props.pid);
      formData.append("type", props.type);
      api
        .post("/M/Server/Collection", formData, {
          params: {
            validate: true,
          },
        })
        .then((res) => {
          if (res) {
            Toast({
              title: res.data.msg,
              type: "success",
            });
            $("#collect img").prop(
              "src",
              "https://beinabncc.oss-cn-beijing.aliyuncs.com/file//icon53-120210417.png"
            );
          }
        })
        .catch((err) => {
          Toast({
            title: err.message || "收藏失败，请联系管理员",
            type: "error",
          });
        });
    }

    function standarddownloadcheck() {
      const formData = new FormData();
      formData.append("id", props.pid);
      Toast({
        title: "下载请移步至电脑端：http://www.biaowu.com/",
        type: "warning",
        duration: 3000,
      });
      // api
      // .post("/M/Server/DownloadCheck", formData)
      // .then((res): void => {
      //   if(!res.data.success){
      //     if(res.data.msg == "请先登录！"){
      //         Toast({
      //             title: res.data.msg,
      //             type: "error"
      //         });
      //     }
      //     if(res.data.msg == "账户积分不足,请充值!"){
      //         Toast({
      //             title: res.data.msg,
      //             type: "error"
      //         });
      //     }
      //     if (res.data.msg == "文件不存在,请联系客服!"){
      //          Toast({
      //             title: res.data.msg,
      //             type: "error"
      //         });
      //     }
      //     if(res.data.msg == "您已购买过此标准，再次下载不需要扣除积分。"){
      //         window.location.href = "/M/Server/Download?id=" + props.pid;
      //     }
      //   }else{
      //        const fData = new FormData();
      //         fData.append("id", props.pid);
      //       api.post("/M/Server/StandardPurchase", fData).then(data => {
      //           if(data.data.success){
      //             if(data.data.msg == "请先登录再执行此操作!"){
      //                 Toast({
      //                     title: data.data.msg,
      //                     type: "error"
      //                 });
      //             }
      //             if(data.data.msg == "您已购买过此标准!"){
      //                 window.location.href = "/M/Server/Download?id=" + props.pid;
      //             }
      //           }else{
      //               window.location.href = "/M/Server/Download?id=" + props.pid;
      //           }
      //       })
      //   }

      // })
      // .catch(err => {
      //   Toast({
      //     title: err.msg || "收藏失败，请联系管理员",
      //     type: "error"
      //   });
      // });
    }

    return {
      // handleAddCart,
      collectAction,
      standarddownloadcheck,
      toViewCart,
      detailToApplyOrder,
      addShopCar,
      storgeBackstage,
      userInfo
    };
  },
});
